import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectSetupBResponse } from '@app/models/project-setup.models';

export interface SectionBFormGroup {
  collectionTargetAmount: FormControl<number>;
  existingCollections: FormControl<number>;
  collectionEndDate: FormControl<Date>;
  notCompletedCollectionCase: FormControl<number | null>;
  minimumOfferAmount: FormControl<number>;
  maximumOfferAmount: FormControl<number>;
  poFunds: FormControl<number | null>;
  communityFunds: FormControl<number>;
}

export function getSectionBFormGroup(
  fb: FormBuilder,
): FormGroup<SectionBFormGroup> {
  return fb.nonNullable.group({
    collectionTargetAmount: fb.nonNullable.control<number>(0),
    existingCollections: fb.nonNullable.control<number>(0),
    collectionEndDate: fb.nonNullable.control<Date>(new Date()),
    notCompletedCollectionCase: fb.control<number | null>(null),
    minimumOfferAmount: fb.nonNullable.control<number>(0),
    maximumOfferAmount: fb.nonNullable.control<number>(0),
    poFunds: fb.control<number | null>(null),
    communityFunds: fb.nonNullable.control<number>(0),
  });
}

export function getSectionBUpdateData(
  formGroup: FormGroup<SectionBFormGroup>,
): ProjectSetupBResponse {
  const date = formGroup.controls.collectionEndDate.value;
  return {
    targetAmount: formGroup.controls.collectionTargetAmount.value,
    currentAmount: formGroup.controls.existingCollections.value,
    targetColletionEndDate: date ? new Date(date).toISOString() : '',
    offerMinAmount: formGroup.controls.minimumOfferAmount.value,
    offerMaxAmount: formGroup.controls.maximumOfferAmount.value,
    ownerCapital: formGroup.controls.communityFunds.value,
    incompleteCollectionResult: formGroup.controls.notCompletedCollectionCase.value,
  };
}

export function patchSectionBForm(
  formGroup: FormGroup<SectionBFormGroup>,
  data: ProjectSetupBResponse,
): void {
  formGroup.controls.collectionTargetAmount.setValue(data.targetAmount);
  formGroup.controls.existingCollections.setValue(data.currentAmount);
  formGroup.controls.collectionEndDate.setValue(
    data.targetColletionEndDate
      ? new Date(data.targetColletionEndDate)
      : new Date(),
  );
  formGroup.controls.minimumOfferAmount.setValue(data.offerMinAmount);
  formGroup.controls.maximumOfferAmount.setValue(data.offerMaxAmount);
  formGroup.controls.communityFunds.setValue(data.ownerCapital);
  formGroup.controls.notCompletedCollectionCase.setValue(
    data.incompleteCollectionResult,
  );
}
